(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-landing"] && !Shopify.designMode) return;
  try {
    
/*
 * Hang Dallas — Artist Landing Page: apply modal.
 * Progressive enhancement. Every [data-hd-al-apply] link keeps a real href
 * to the apply page; this only intercepts the click when the modal exists.
 * No JS, or this file failing to run, still gets you the application.
 */
(function () {
  function init() {
    var modal = document.getElementById('hd-al-apply-modal');
    if (!modal || modal.dataset.hdWired) return;
    modal.dataset.hdWired = '1';

    var panel = modal.querySelector('.hd-al__modal-panel');
    var closeBtn = modal.querySelector('[data-hd-al-close]');
    var formHost = modal.querySelector('[data-hd-al-form-host]');
    var formTpl = modal.querySelector('[data-hd-al-form-tpl]');
    var status = modal.querySelector('[data-hd-al-status]');
    var applyHref = (document.querySelector('[data-hd-al-apply]') || {}).href || '/pages/apply';
    var mounted = false;
    var lastFocus = null;

    var LOAD_TIMEOUT_MS = 15000;

    // Mount the HubSpot embed the first time the modal opens. It cannot be
    // mounted earlier: Chrome does not lay out iframes in a hidden subtree,
    // so the form measures itself at zero and stays collapsed. See the
    // comment on the modal markup.
    function mountForm() {
      if (mounted || !formTpl || !formHost) return;
      mounted = true;

      formHost.appendChild(formTpl.content.cloneNode(true));

      // Cloned <template> scripts never execute. Swap each for a fresh one.
      Array.prototype.forEach.call(formHost.querySelectorAll('script'), function (old) {
        var fresh = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) {
          fresh.setAttribute(a.name, a.value);
        });
        fresh.text = old.textContent;
        old.parentNode.replaceChild(fresh, old);
      });

      var started = Date.now();
      var poll = setInterval(function () {
        var frame = formHost.querySelector('.hs-form-frame, iframe');
        var tall = frame && frame.getBoundingClientRect().height > 80;
        if (tall) {
          clearInterval(poll);
          if (status) status.remove();
        } else if (Date.now() - started > LOAD_TIMEOUT_MS) {
          clearInterval(poll);
          if (status) {
            status.classList.add('hd-al__modal-status--failed');
            status.innerHTML =
              'The form is taking longer than it should. ' +
              '<a href="' + applyHref + '">Open the full application page</a> instead.';
          }
        }
      }, 400);
    }

    function open(e) {
      // Let modified clicks (new tab / new window) through to the real page.
      if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hd-al--modal-open');
      if (closeBtn) closeBtn.focus();
      mountForm();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hd-al--modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-hd-al-apply]').forEach(function (link) {
      link.addEventListener('click', open);
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (!panel.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    // Keep tabbing inside the panel while it is open.
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
      var f = panel.querySelectorAll('a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // The theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["do214-landing"] && !Shopify.designMode) return;
  try {
    
/*
 * Hang Dallas — Do214 landing page: outbound click tracking.
 *
 * Fires a GA4 event named `landing_event_click` when someone leaves this page
 * for events.hangdallas.com, carrying { event_slug, placement, campaign }.
 *
 * The name matters. `begin_checkout` is already mapped by Shopify's Google
 * pixel to artwork checkouts on this store, and `ticket_checkout` is already
 * used by the events site's Get Tickets buttons — reusing either would
 * contaminate an existing key event or double-count one journey.
 *
 * ONE delegated listener per section root, so a click fires exactly once. No
 * per-link handlers (they duplicate on theme-editor re-render) and no debounce
 * (a debounce here silently swallows the second click on a second tile).
 *
 * The links are never blocked or delayed: gtag sends this over sendBeacon, so
 * navigation and the hit do not race.
 */
(function () {
  var CAMPAIGN_KEY = 'hdD214Campaign';

  function resolveCampaign(root) {
    var fallback = root.getAttribute('data-d214-campaign') || '';
    var found = '';

    try {
      found = new URLSearchParams(window.location.search).get('utm_campaign') || '';
    } catch (e) {
      /* No URLSearchParams, or a hostile query string. Fall through. */
    }

    // Remember it, so the value survives a scroll-around that drops the query
    // string, and so a visitor who arrives via the email and wanders still
    // reports the campaign they actually came in on.
    try {
      if (found) {
        window.sessionStorage.setItem(CAMPAIGN_KEY, found);
      } else {
        found = window.sessionStorage.getItem(CAMPAIGN_KEY) || '';
      }
    } catch (e) {
      /* Private mode / storage disabled. The fallback below still applies. */
    }

    return found || fallback;
  }

  function send(name, params) {
    // Shopify's Google & YouTube pixel runs with runtimeContext OPEN on this
    // store, so the Google tag's globals are on window rather than locked in
    // the pixel sandbox. gtag is checked first; dataLayer is the belt-and-
    // braces path if the tag ever moves behind GTM.
    //
    // Deliberately no `send_to`: gtag routes a bare event to every configured
    // destination, which includes G-PG8M09EYK9. Naming one instance would
    // silently drop the hit if the instance id ever changed.
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
      return;
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var payload = { event: name };
      for (var key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) payload[key] = params[key];
      }
      window.dataLayer.push(payload);
    }
  }

  function wire(root) {
    if (!root || root.dataset.d214Wired === '1') return;
    root.dataset.d214Wired = '1';

    var campaign = resolveCampaign(root);

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var link = target.closest('[data-d214-event]');
      if (!link || !root.contains(link)) return;

      send('landing_event_click', {
        event_slug: link.getAttribute('data-d214-event') || '',
        placement: link.getAttribute('data-d214-placement') || '',
        campaign: campaign
      });
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-d214-root]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /*
   * Omnisend popup signups → lead events.
   *
   * Verified against Omnisend's docs (api-docs.omnisend.com/reference/
   * omnisend-forms-events): the script dispatches a CustomEvent named
   * `omnisendForms` on window, and detail.eventName === 'submit' is the
   * successful primary conversion, fired once per form. 'view',
   * 'interaction' and 'close' are NOT conversions and are ignored here.
   *
   * Omnisend does not fire GA4 generate_lead or the Meta / Reddit / TikTok
   * Lead events by itself, which is the gap this closes. Reddit and TikTok are
   * feature-detected: neither pixel is on hangdallas.com today (checked 25 Aug
   * 2026 — only Meta is), so those two branches sit dormant until the pixels
   * are added, at which point they start working with no code change.
   *
   * OFF by default. A Meta `Lead` event feeds ad optimisation, so turning this
   * on is a decision about the ad account, not about the page. The switch is
   * "Report popup signups as leads" in the section settings.
   */
  function reportLeads() {
    var seen = {};

    window.addEventListener('omnisendForms', function (event) {
      var detail = event && event.detail;
      if (!detail || detail.eventName !== 'submit') return;
      if (!document.querySelector('[data-d214-report-leads]')) return;

      // Belt and braces against a form that re-announces itself.
      var formId = (detail.form && detail.form.id) || 'unknown';
      if (seen[formId]) return;
      seen[formId] = true;

      var formName = (detail.form && detail.form.name) || '';

      send('generate_lead', {
        method: 'omnisend_popup',
        form_id: formId,
        form_name: formName,
        placement: 'do214-landing'
      });

      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: formName || formId });
      }
      if (window.rdt && typeof window.rdt === 'function') {
        window.rdt('track', 'Lead');
      }
      if (window.ttq && typeof window.ttq.track === 'function') {
        window.ttq.track('SubmitForm', { content_name: formName || formId });
      }
    });
  }

  reportLeads();

  // Theme editor: the section is torn down and reprinted on every setting change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
